import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { auth, signInWithEmailAndPassword, sendPasswordResetEmail } from './firebase';

const colors = {
  background: '#FAFAFA',
  primary: '#F0EAE2',
  text: '#333333',
};

const Login = ({ onLogin, onToggle }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError(null); // Clear previous errors
    setMessage(null); // Clear previous messages

    try {
      console.log("Attempting login with email:", email);
      await signInWithEmailAndPassword(auth, email, password);
      console.log("Login successful for email:", email);
      console.log("Current User:", auth.currentUser);

      if (typeof onLogin === 'function') {
        onLogin(); // Call the onLogin callback if provided
      }
    } catch (error) {
      console.error("Authentication Error:", error);

      // Handle specific error codes
      switch (error.code) {
        case 'auth/user-not-found':
          setError('Aucun utilisateur trouvé avec cette adresse e-mail.');
          break;
        case 'auth/wrong-password':
          setError('Mot de passe incorrect. Veuillez réessayer.');
          break;
        case 'auth/invalid-email':
          setError('Format de le-mail i’nvalide.');
          break;
        case 'auth/too-many-requests':
          setError('L’accès à ce compte a été temporairement désactivé en raison de trop nombreuses tentatives de connexion échouées. Vous pouvez immédiatement le restaurer en réinitialisant votre mot de passe ou réessayer plus tard.');
          break;
        default:
          setError('Échec de connexion. Veuillez vérifier vos identifiants.');
      }
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setError('Veuillez entrer votre adresse e-mail pour réinitialiser votre mot de passe.');
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Un e-mail de réinitialisation de mot de passe a été envoyé. Veuillez vérifier votre boîte de réception.');
    } catch (error) {
      console.error('Error sending password reset email:', error);
      setError('Failed to send password reset email. Please try again.');
    }
  };

  useEffect(() => {
    console.log('Current User:', auth.currentUser);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#FAFAFA] p-4">
      <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-lg">
        <h2 className="text-2xl font-bold text-center mb-6 text-[#333333]">Move Ö Miel</h2>
        <form onSubmit={handleLogin}>
          <input
            className="w-full px-4 py-2 mb-4 border border-[#E0E0E0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F0EAE2]"
            type="email"
            placeholder="Adresse e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            className="w-full px-4 py-2 mb-6 border border-[#E0EAE0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F0EAE2]"
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="text-red-500 mb-4">{error}</p>}
          {message && <p className="text-green-500 mb-4">{message}</p>}
          <button type="submit" className="w-full bg-[#F0EAE2] text-[#333333] py-2 rounded-lg flex items-center justify-center transition-all hover:bg-[#E0EAE0]">
            Connexion
            <ArrowRight className="ml-2" size={18} />
          </button>
        </form>
        <button
          onClick={onToggle}
          className="mt-4 w-full bg-[#F0EAE2] text-[#333333] py-2 rounded-lg flex items-center justify-center transition-all hover:bg-[#E0EAE0]"
        >
          Vous n’avez pas de compte ? Inscrivez-vous
        </button>
        <button
          onClick={handlePasswordReset}
          className="mt-2 text-sm text-[#333333] underline"
        >
          Mot de passe oublié ? Réinitialisez votre mot de passe
        </button>
      </div>
    </div>
  );
};

export default Login;
